import { render, staticRenderFns } from "./textlist_1.vue?vue&type=template&id=88e88156&scoped=true"
import script from "./textlist_1.vue?vue&type=script&lang=js"
export * from "./textlist_1.vue?vue&type=script&lang=js"
import style0 from "./textlist_1.vue?vue&type=style&index=0&id=88e88156&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e88156",
  null
  
)

export default component.exports